import { render, staticRenderFns } from "./Cgu.vue?vue&type=template&id=238d65b6"
var script = {}
import style0 from "./Cgu.vue?vue&type=style&index=0&id=238d65b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports